import "prismjs";
import "prismjs/components/prism-q";
